import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { CaseFormType } from '@features/forms/CaseForms/schema';
import { useCaseByIdQuery } from '@/queries/case';

export const useReallocationTrialPrograms = (reAllocationCaseId?: string | null) => {
  const { setValue } = useFormContext<CaseFormType>();

  const { data: referenceCase } = useCaseByIdQuery(reAllocationCaseId!, !!reAllocationCaseId);

  useEffect(() => {
    if (referenceCase) {
      setValue('reAllocationCaseTrialProgram', referenceCase.trialProgram);
    }
  }, [referenceCase, setValue]);
};
